// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'purchase-order.term': 'Due on receipt | {count} days',
    'purchase-order.custom': 'Custom',

    'purchase-order.page.title': 'Purchase Orders',
    'purchase-order.page.search_results': 'Search Results',
    'purchase-order.page.create.title': 'Create Purchase Order',
    'purchase-order.page.search.title': 'Find Purchase Orders',
    'purchase-order.page.edit.title': 'Edit Purchase Order',
    'purchase-order.page.title.receive_items': 'Receive Items',
    'purchase-order.page.view.history': 'Audit Trail',
    'purchase-order.page.all': 'All',
    'purchase-order.page.import_bill': 'Create Import Bill',

    'purchase-order.button.confirm': 'Confirm',
    'purchase-order.button.cancel': 'Cancel',
    'purchase-order.button.select': 'Select',
    'purchase-order.button.find': 'Find Purchase Orders',
    'purchase-order.button.search': 'Apply',
    'purchase-order.button.create': 'Save Purchase Order',
    'purchase-order.button.new': 'New Purchase Order',
    'purchase-order.button.save': 'Save Changes',
    'purchase-order.button.save_bill': 'Save Bill',
    'purchase-order.button.refund_purchase_order': 'Refund Purchase Order',
    'purchase-order.button.edit': 'Edit',
    'purchase-order.button.draft': 'Save Draft',
    'purchase-order.button.restore': 'Restore',
    'purchase-order.button.reset': 'Reset',
    'purchase-order.button.history': 'Audit Trail',
    'purchase-order.button.rollback': 'Rollback Purchase Order',
    'purchase-order.button.cancel_draft': 'Cancel Draft',
    'purchase-order.button.receive_items': 'Receive items',
    'purchase-order.button.update_inventory': 'Update Inventory',
    'purchase-order.button.add_bill': 'Add Bill',
    'purchase-order.button.add_import_bill': 'Add Import Bill',

    'purchase-order.placeholder.search': 'Search purchase orders',

    'purchase-order.message.no_change': 'This purchase order has not changed since it was created.',
    'purchase-order.message.quantity_exceeded': 'Received more than expected ({quantity})',
    'purchase-order.message.bill_quantity_exceeded': 'Billing more than ordered.',
    'purchase-order.message.mismatch_total': "Totals don't match.",

    'purchase-order.link.create_first_purchase_order': 'Click here to create your first purchase order',
    'purchase-order.link.purchase orders': ' Return to Purchase Orders',
    'purchase-order.link.retry': 'Click here to retry',

    'purchase-order.checkbox.all': 'Check All',
    'purchase-order.checkbox.actions_label': 'with selected',

    'purchase-order.label.purchase order': 'Purchase Order',
    'purchase-order.label.purchase_order_type': 'Purchase Order Type',
    'purchase-order.label.purchase_order_category': 'Purchase Order Category',
    'purchase-order.label.date': 'Date',
    'purchase-order.label.due': 'Due',
    'purchase-order.label.item': 'Item',
    'purchase-order.label.unit_cost': 'Unit Cost',
    'purchase-order.label.quantity': 'Quantity',
    'purchase-order.label.quantity_ordered': 'Quantity Ordered',
    'purchase-order.label.quantity_received': 'Quantity Received',
    'purchase-order.label.quantity_receiving': 'Quantity Receiving',
    'purchase-order.label.quantity_billed': 'Quantity Billed',
    'purchase-order.label.bill_quantity': 'Bill Quantity',
    'purchase-order.label.tax': 'Tax',
    'purchase-order.label.account': 'Account',
    'purchase-order.label.total': 'Total',
    'purchase-order.label.tax_total': 'Tax Total',
    'purchase-order.label.grand_total': 'Grand Total',
    'purchase-order.label.sub_total': 'Subtotal',
    'purchase-order.label.discount': 'Discount',
    'purchase-order.label.bill_from': 'Bill From',
    'purchase-order.label.balance': 'Balance',
    'purchase-order.label.subject': 'Subject',
    'purchase-order.label.to': 'To',
    'purchase-order.label.message': 'Message',
    'purchase-order.label.purchase_order_number': 'Purchase Order No',
    'purchase-order.label.transaction_date': 'Transaction Date',
    'purchase-order.label.paid_at': 'Paid At',
    'purchase-order.label.due_at': 'Due At',
    'purchase-order.label.is_imported': 'Imported',
    'purchase-order.label.imported': 'IMPORTED',
    'purchase-order.label.uploaded': 'UPLOADED',
    'purchase-order.label.inventory_value': 'Inventory Value',
    'purchase-order.label.appropriated_cost': 'Landing Cost Distribution',
    'purchase-order.label.applied_cost': 'Landed Cost Per Unit',
    'purchase-order.label.total_unit_cost': 'Total Unit Cost',

    'purchase-order.label.entity_name': 'Supplier',
    'purchase-order.label.contact_entity_name': 'Contact',
    'purchase-order.label.contact_name': 'Contact Name',
    'purchase-order.label.address_line_1': 'Address Line 1',
    'purchase-order.label.address_line_2': 'Address Line 2',
    'purchase-order.label.province': 'Province',
    'purchase-order.label.postal_code': 'Postal Code',
    'purchase-order.label.country_name': 'Country',
    'purchase-order.label.reference_number': 'Reference No',
    'purchase-order.label.purchase_order': 'Purchase Order',
    'purchase-order.label.term': 'Term',
    'purchase-order.label.currency_name': 'Currency',

    'purchase-order.label.currency_sub_total_in_cents': 'Subtotal',
    'purchase-order.label.currency_discount_total_in_cents': 'Discount Total',
    'purchase-order.label.currency_tax_total_in_cents': 'Tax Total',
    'purchase-order.label.currency_grand_total_in_cents': 'Grand Total',
    'purchase-order.label.currency_balance_owing_in_cents': 'Balance Owing',
    'purchase-order.label.currency_shipping_total_in_cents': 'Shipping Total',
    'purchase-order.label.system_shipping_total_in_cents': 'System Shipping Total',

    'purchase-order.label.sold_by': 'Sold By',
    'purchase-order.label.public_customer_message': 'Public Customer Message',
    'purchase-order.label.private_note': 'Private Note',
    'purchase-order.label.created_at': 'Created on',
    'purchase-order.label.void_reason': 'Reason for voiding purchase order',
    'purchase-order.label.cancel_reason': 'Reason for canceling purchase order',
    'purchase-order.label.refund_reason': 'Reason for refunding purchase order',
    'purchase-order.label.rollback_reason': 'Reason for rolling back purchase order',

    'purchase-order.sort.field_label': 'Field',
    'purchase-order.sort.direction_label': 'Direction',
    'purchase-order.sort.direction_ascending': 'Ascending',
    'purchase-order.sort.direction_descending': 'Descending',

    'purchase-order.modal.title.purchase_order_void': 'Void Purchase Order',
    'purchase-order.modal.title.purchase_order_restore': 'Restore Purchase Order',
    'purchase-order.modal.title.purchase_order_cancel': 'Cancel Draft Purchase Order',
    'purchase-order.modal.title.purchase_order_rollback': 'Rollback Purchase Order',
    'purchase-order.modal.title.excess_items': 'Excess Items',

    'purchase-order.modal.message.purchase_order_void': 'Are you sure that you want to void this purchase order? This action cannot be undone. | Are you sure that you want to void these purchase orders? This action cannot be undone.',
    'purchase-order.modal.message.purchase_order_restore': 'Are you sure that you want to restore this purchase order? | Are you sure that you want to restore these purchase orders?',
    'purchase-order.modal.message.purchase_order_cancel': 'Are you sure that you want to cancel this draft? This action cannot be undone.| Are you sure that you want to cancel these drafts? This action cannot be undone.',
    'purchase-order.modal.message.excess_items_receiving': 'You are receiving more items than you ordered. Do you want to continue?',
    'purchase-order.modal.message.excess_items_billing': 'You are paying for more items than you ordered. Do you want to continue?',

    'purchase-order.success.message.purchase_order_created': 'Your purchase order has been created',
    'purchase-order.success.message.purchase_order_updated': 'Your purchase order has been updated',
    'purchase-order.success.message.purchase_order_restored': 'Your purchase order has been restored | All selected purchase orders were restored',
    'purchase-order.success.message.purchase_order_cancelled': 'Your draft purchase order has been cancelled',
    'purchase-order.success.message.purchase_order_voided': 'Your purchase order has been voided',
    'purchase-order.success.message.purchase_order_rolled_back': 'Your purchase order has been rolled back',

    'purchase-order.page.landed_cost': 'Apply Landed Cost',
    'purchase-order.button.apply_landed_cost': 'Apply Landed Cost',
    'purchase-order.label.freight_bill': 'Freight bill',
    'purchase-order.label.freight_amount': 'Amount',
    'purchase-order.label.allocation_basis': 'This bill covers',
    'purchase-order.label.basis_received': 'This delivery',
    'purchase-order.label.basis_ordered': 'The whole order',
    'purchase-order.label.allocation_units': 'Units',
    'purchase-order.label.line_value': 'Value',
    'purchase-order.label.share': 'Share',
    'purchase-order.label.appropriated_cost': 'Cost',
    'purchase-order.label.allocated_total': 'Allocated',
    'purchase-order.help.allocation_basis':
        'A freight bill against a part-received order is ambiguous, and nothing in the data can settle it. Choose “this delivery” and the whole cost rides on the units that have arrived; choose “the whole order” and the units still in transit keep their share for when they land.',
    'purchase-order.help.landed_cost': 'Freight paid to bring goods in is part of what they cost. Applying a bill here raises the unit cost of the lines it brought in, so cost of sales tells the truth when they are sold.',
    'purchase-order.error.message.no_freight_expenses': 'No posted bill carries a freight charge. Add the freight to a supplier bill first, then apply it here.',
    'purchase-order.error.message.allocation_mismatch': 'The lines must add up to the freight amount exactly. They currently differ by {difference}.',
    'purchase-order.success.message.landed_cost_applied': 'The freight has been added to the cost of the goods',

    'purchase-order.error.message.purchase_order_deleted': 'This purchase order was already permanently deleted | These purchase orders were already permanently deleted',
    'purchase-order.error.message.purchase_order_restored': 'This purchase order was already restored | These purchase orders were already restored',
    'purchase-order.error.message.error_loading_page': 'Sorry, there was an error loading purchase order.| Sorry, there was an error loading purchase orders.',
};
